export const URL_BASE = "https://campusvirtualapi-beta.azurewebsites.net/";
//export const URL_BASE = "http://localhost:56899/";
//export const URL_BASE = 'https://campusvirtualapi.azurewebsites.net/';
// export const URL_BASE =
//   "https://3605-2806-310-16a-478e-ac01-8e98-9607-df10.ngrok-free.app/";
//Token
export const DEFTKN =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJDYW1wdXNWaXJ0dWFsQXBpIiwiaWF0IjoiMTU1NTgwMjcwOCIsImV4cCI6IjE4NzE0MjE5MDUiLCJlbWFpbCI6IldlYlBheVBsdXNAc2lzLmVkdS5teCIsImlkX2luc3RpdHVjaW9uIjoiMSIsImlkX3BlcnNvbmEiOiIyIiwiY2FuYWxfY29tdW5pY2FjaW9uIjoiIiwibW9vZGxlX3VzZXJfaWQiOiIiLCJtb29kbGVfdG9rZW4iOiIiLCJyb2wiOiIiLCJhbHVtbm8iOiIiLCJnbXQiOiItNiJ9.fTo8irf2IeUcDR8tOjU81TVVAXgrg_yf9yYZjIM9jbk";
// {
//   "iss": "CampusVirtualApi",
//   "iat": "1555802708",
//   "exp": "1871421905",  //20 Abril 2029
//   "email": "WebPayPlus@sis.edu.mx",
//   "id_institucion": "1",
//   "id_persona": "2",
//   "canal_comunicacion": "",
//   "moodle_user_id": "",
//   "moodle_token": "",
//   "rol": "",
//   "alumno": "",
//   "gmt": "-6"
// }

export const DEFTKN_ =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJDYW1wdXNWaXJ0dWFsQXBpIiwiaWF0IjoiMTc4MzUxOTA3NyIsImV4cCI6IjIwOTkxMzgyNzQiLCJlbWFpbCI6IldlYlBheVBsdXNAc2lzLmVkdS5teCIsImlkX2luc3RpdHVjaW9uIjoiNSIsImlkX3BlcnNvbmEiOiIyIiwiY2FuYWxfY29tdW5pY2FjaW9uIjoiIiwibW9vZGxlX3VzZXJfaWQiOiIiLCJtb29kbGVfdG9rZW4iOiIiLCJyb2wiOiIiLCJhbHVtbm8iOiIiLCJnbXQiOiItNiJ9.R2qXBxXWphESdeDSph3AYHTPSC42gx0AN0ezUcqnUv0";
// {
//   "iss": "CampusVirtualApi",
//   "iat": "1783519077",
//   "exp": "2099138274",  //08 Julio 2036
//   "email": "WebPayPlus@sis.edu.mx",
//   "id_institucion": "5", // Local Db_Sia
//   "id_persona": "2",
//   "canal_comunicacion": "",
//   "moodle_user_id": "",
//   "moodle_token": "",
//   "rol": "",
//   "alumno": "",
//   "gmt": "-6"
// }

//CardPay Url
export const URL_CARDPAY = "https://oppwa.com/";

// ID_INSTITUCION 1 = UAL 5 = Local Db_Sia
export const ID_INSTITUCION = 1;

export const URL_HOSTING = "https://pagos-dev.campusvirtual.mx/";
//export const URL_HOSTING = "https://pagos.campusvirtual.mx/";
//export const URL_HOSTING =
//  "https://048c-2806-310-16a-478e-ac01-8e98-9607-df10.ngrok-free.app/";

export default URL_BASE;
